import { HttpEventType } from '@angular/common/http';
import { Component, Optional } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { firstValueFrom } from 'rxjs';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { StorePriceImportModel } from 'src/app/models/imports/store-price-import-model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { StorePriceService } from 'src/app/services/subrental/store-price.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-import-store-price',
  templateUrl: './import-store-price.component.html',
  styleUrls: ['./import-store-price.component.scss'],
  standalone: false
})
export class ImportStorePriceComponent {

  eventFile: any;
  errorStorePrice: number = 0;
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = '';
  storePriceAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  storePriceImport: boolean = false;
  visibleTxt: boolean = false;

  constructor(
    private storePriceService: StorePriceService,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef) {
  }

  attach() {
    document.getElementById('fileImport')?.click();
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      this.eventFile.target.value = '';
    }
  }

  close() {
    const data: ModalObjectType = {};
    if (this.storePriceImport) {
      data.params = { reload: true };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  downloadErrorsTxt() {
    if (!this.storePriceAlerts || this.storePriceAlerts.length === 0) {
      this.toastHandlerService.showToast('error', 'No hay alertas para exportar');
      return;
    }

    this.storePriceService.exportImportErrors(this.storePriceAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionPreciosporBodega_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast('error', 'Error al exportar el archivo');
      }
    });
  }

  downloadGuideImport() {
    this.storePriceService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaPreciosPorBodega.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  importStorePrices() {
    this.storePriceAlerts = [];
    this.errorStorePrice = 0;
    this.visibleTxt = false;
    let isOk: boolean = true;
    const input = document.getElementById("fileImport") as any;
    const rowsImports = new Array<StorePriceImportModel>();
    let row: StorePriceImportModel;
    let counter: number = 1, branchCode: number, storeCode: number, articleCode: number, unitValue: number;
    if (input.files[0]) {
      readXlsxFile(input.files[0]).then(async (rows) => {
        if (rows.length <= 1) {
          this.toastHandlerService.showToast('error', 'El archivo ingresado no tiene registros para importar.');
          return;
        }
        rows.splice(0, 1);
        rows.forEach(element => {
          counter = counter + 1;
          let rowHasError = false;

          //A. Código Sucursal:
          branchCode = parseFloat(element[0] as string);
          if (isNaN(branchCode)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}. El código de la sucursal no es válido.`;
            this.storePriceAlerts.push(alert);
            rowHasError = true;
          }

          //B. Código Bodega:
          storeCode = parseFloat(element[1] as string);
          if (isNaN(storeCode)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}. El código de la bodega no es válido.`;
            this.storePriceAlerts.push(alert);
            rowHasError = true;
          }

          //C. Código Artículo:
          articleCode = parseFloat(element[2] as string);
          if (isNaN(articleCode)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}. El código del artículo no es válido.`;
            this.storePriceAlerts.push(alert);
            rowHasError = true;
          }

          //D. Valor Unitario:
          unitValue = parseFloat(element[3] as string);
          if (isNaN(unitValue)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}. El valor unitario no es válido.`;
            this.storePriceAlerts.push(alert);
            rowHasError = true;
          }

          if (!rowHasError) {
            row = new StorePriceImportModel(counter, branchCode, storeCode, articleCode, unitValue);
            rowsImports.push(row);
          } else {
            isOk = false;
          }

        });
        if (isOk && rowsImports.length > 0) {
          try {
            const response = await firstValueFrom(this.storePriceService.importStorePrices(rowsImports));
            this.loadPreInvoicingModel = response;
            this.storePriceAlerts = response?.alerts ?? [];
            this.errorStorePrice = response?.preInvoicingStateId;

            if (this.errorStorePrice === 1) {
              this.visibleTxt = true;
              this.toastHandlerService.showToast(
                'error',
                'La importación terminó con errores, puede exportarlos si lo desea.',
                'ERROR');
            } else if (this.storePriceAlerts.length > 0) {
              this.visibleTxt = true;
              this.toastHandlerService.showToast('error', 'La importación terminó con alertas, puede exportarlas si lo desea');
            } else {
              this.visibleTxt = false;
              this.toastHandlerService.showToast('success', `La importación terminó exitosamente.`);
            }
            this.storePriceImport = true;
            this.clearInputFile();
          } catch (error) {
            this.nameFile = 'Ningún archivo seleccionado.';
            console.error('Error al importar Precios por Bodega.', error);
          }
        } else {
          this.errorStorePrice = 1;
          this.visibleTxt = true;
          this.toastHandlerService.showToast(
            'error',
            'La importación terminó con errores, puede exportarlos si lo desea'
          );
        }
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No ha seleccionado ningún archivo'
      })
    }
  }
}
